"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _indexModule = _interopRequireDefault(require("./index.module.css"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../Button/Button");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UseSms = function UseSms(_ref) {
  var message = _ref.message,
    callback = _ref.callback,
    dismiss = _ref.dismiss;
  /*const smsRef = useRef();*/
  var header = /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.header
  }, /*#__PURE__*/_react.default.createElement("h1", null, "\u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8 SMS \u10D9\u10DD\u10D3\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0"));
  var body = /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.body
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    className: _indexModule.default.form,
    noValidate: true,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log(e.target);
      //callback(smsRef.current.value);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _indexModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    style: {
      color: 'var(--bs-danger)',
      marginBottom: '1.5rem'
    }
  }, message), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: 'number',
    isInvalid: !!message
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    gap: 4,
    className: _indexModule.default.buttonsContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'success',
    type: 'submit'
  }, "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'secondary',
    onClick: dismiss
  }, "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"))));
  /*const footer = (
    <div className={classes.footer}>
      </div>
  );*/
  return {
    header: header,
    body: body /*, footer*/
  };
};
var _default = UseSms;
exports.default = _default;